<template>
  <bm-dialog
    :label="$m.support_report_a_bug"
    width="unset"
    @cancel="cancel"
    @accept="accept(feedback)"
  >
    <v-container fluid pa-0>
      <v-row justify="center" align="center">
        <v-col v-if="imgUrl" cols="auto">
          <v-img
            class="screenshot"
            :src="imgUrl"
            :max-width="400"
            :max-height="300"
            contain
          />
        </v-col>
        <v-col v-else :style="{ width: '300px' }">
          {{ $m.support_unable_to_screenshot }}
        </v-col>
        <v-col cols="auto" :style="{ width: '350px' }">
          <bm-text-area
            :value.sync="feedback"
            :t="$m.keys.description"
            :rules="[$ruleSet.required()]"
            :placeholder="$m.support_feedback_placeholder"
          />
        </v-col>
      </v-row>
    </v-container>
    <template #controls-confirm-text>
      {{ $m.send }}
    </template>
  </bm-dialog>
</template>

<script setup lang="ts">
import BmDialog from "@/components/dialogs/BmDialog.vue";
import {
  useReactiveDialogScriptSetup,
  type DialogEvents,
} from "@/components/mixins/dialogs";
import { ref } from "vue";

export interface SendScreenshotDialogProps {
  imgUrl?: string;
  screenshotFailed?: boolean;
}

export interface SendScreenshotDialogEvents extends DialogEvents<string> {}

withDefaults(defineProps<SendScreenshotDialogProps>(), {
  imgUrl: "",
  screenshotFailed: false,
});

const emit = defineEmits<SendScreenshotDialogEvents>();

const feedback = ref("");
const { accept, cancel } = useReactiveDialogScriptSetup<string>(emit);
</script>

<style lang="sass" scoped>
@import "src/sass/colours"

.screenshot
  border: 1px solid $bm-color-brand01
</style>
